// +----------------------------------------------------------------------
// | 桌子工作室 [webSokcet] V0.12015014  Released
// |  上行数据 clinet   下行数据 service
// +----------------------------------------------------------------------
// | Copyright (c) 2018-2019 ，MrTable All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ( http://www.apache.org/licenses/LICENSE-2.0 )
// +----------------------------------------------------------------------
// | Author: Mr Table <admin@hjf.pw>
// +----------------------------------------------------------------------
import CryptoJS from "../vendor/CryptoJS";
import Message from "../vendor/Message";
export class WebSocket {
    opts = {};
    //fdsD
    fdSc = 0;
    //消息累加
    incIndex = 0;
    //scoket
    socketTask = null;
    //是否已连接
    socketOpen = false;
    //临时获取数据
    tmpData = [];
    //事件返回
    eventCall = (code,res)=>{};
    //定时器心跳包
    timerId = 0;
    //定时器重发包
    reTimerId = 0;
    /*****重发机制参数需求****/
    //临时缓存包文件
    tmpCliData = [];
    //重试次数
    retryCount = 5;
    //触发重发间隔时间 5s
    retryTime = 5000;
    /*****服务端缓存包*****/
    //缓存包文件
    tmpSerData = [];

    constructor(opt) {
        let option = {wsUrl:""};
        this.opts = this.extend(option,opt);
    }
    //连接socket
    connect() {
        var that = this;
        this.isClose = false;
        this.tmpCliData = [];
        this.tmpSerData = [];
        this.socketTask = new wxSocket({
            wsUrl  : this.opts.wsUrl,
            onOpen:( () => {
                console.log("WebSocket连接成功");
                this.socketOpen = true;
                this.eventCall('onOpen','');
                this.heartBeat();
            }),
            onMessage:onMessage => {
                let aData = that.asyMessage(onMessage);
                if (aData == null || aData == '') return;
                //确认帧
                if (aData.msgType == 2) {
                    this.ackFrame(aData);
                    return;
                }
                //检查server包重复状态
                if (this.checkFrame(aData)) {
                    this.eventCall('onSendSuccess', aData);
                    return;
                }
                //缓存server包
                this.tmpSerData.push({ time: Date.parse(new Date()),data: aData, msgId: aData.msgId});
                aData.isReSend = true;
                console.log("----接受数据----");
                console.log(aData);
                console.log("-----结束数据----");
                if(aData.isAsk) {
                    this.eventCall('onMessage', aData);
                    let obj 	= new Message();
                    obj.code 	= aData.code;
                    obj.msgType = 2;
                    obj.askId 	= aData.id;
                    obj.data 	= "";//
                    obj.rests 	= aData.rests;
                    this.send(obj.getData(),false);
                } else {
                    this.eventCall('onMessage', aData);
                }
            },
            //链接错误
            onError: res=>{
                console.log("WebSocket连接错误");
                this.socketOpen = false;
                if (res.errMsg != 'exceed max task count'){
                   this.eventCall('onError', res.errMsg);
                    if(!this.isClose) this.reConnon();
                } else {
                   this.eventCall('onStop', res.errMsg);
                }
            },
            //链接关闭
            onClose:res => {
                console.log("WebSocket已关闭");
                this.socketOpen = false;
                this.eventCall('onClose', '');
                this.socketTask.socket.close();
                if(!this.isClose) this.reConnon();
            }
        });
    }
    /**
     * 发送消息
     * @param data 消息数据
     * @param isAck 是否服务器确认帧【如果未确认帧，发送5条】
     * @param fn 发送成功
     * @param error 发送失败
     */
    send(data,isAck = true,fn = null,error = null){
        if (!this.socketOpen) { return null; }
        try {
            //生成消息
            if (data.id == "") data.id = this.createMsgId();
            //解析加密数据
            let AES = new CryptoJS.AES(this.opts.key);
            let jsonStr = AES.encrypt(JSON.stringify(data));
            //发送消息
            this.socketTask.send({data: jsonStr});
            console.log("发送数据---");
            console.log(data);
            console.log("结束数据---")
            //是否需要缓存重发
            if (!isAck) {
                if(fn != null)fn(data.data);
                return;
            }
            //是否缓存存在
            let findData = this.findCliMsgId(data.id);
            if (findData == null){
                this.tmpCliData.push({
                    'msgId'     : data.id,//消息ID
                    'data'      : data,
                    'count'     : 1,//尝试次数
                    'time'      : Date.parse(new Date()),//最后发送时间
                    'code'      : 0,//
                    'fn'		: fn,//成功
                    'error'	    : error//失败
                });
            }
            return data.id;
        } catch (e) {
            console.log(e.message);
            if(error != null) error(data.data);
            return null;
        }
    }
    /**
     * 设置事件
     */
    addListener(event) {
        this.eventCall = event;
    }
    /**
     * 关闭链接
     */
    close(){
        clearInterval(this.timerId);
        clearInterval(this.reTimerId);
        this.isClose = true;
        if(this.socketTask != null)  this.socketTask.socket.close();
    }
    /**
     * 心跳包
     */
    heartBeat() {
        //检查是否已经开启心跳包模式
        if(this.timerId > 0) {
            clearInterval(this.timerId);
        }
        this.timerId = setInterval(function () {
            if (this.socketTask.readyState == 1) {
                this.socketTask.send({ data: '01'});
                this.eventCall('onHeartBeat', {});
            }
        }.bind(this), 10 * 1000);

        //开启重发包模式
        if(this.reTimerId > 0) {
            clearInterval(this.reTimerId);
        }
        this.reTimerId = setInterval(function () {
            if (this.socketTask.readyState == 1) {
                //重发机制 | 清理下行包
                this.reSend();
                this.clerSerData();
            }
        }.bind(this), 5 * 1000);
        return this;
    }
    /**
     * 重发数据包
     */
    reSend(){
        let time = Date.parse(new Date());
        for (let i in this.tmpCliData) {
            let data = this.tmpCliData[i];
            //重发数据包
            if(data.count < this.retryCount && (time - data.time) >= this.retryTime) {
                data.time = time;
                data.count ++;
                this.eventCall('onReSend',data);
                this.send(data.data,false,null,null);
            } else {
                //超过重发数据 | 【提示发送失败】
                if(data.count >= this.retryCount) {
                    this.eventCall('onSendError', data.data);
                    if(data.error != null) data.error();
                    this.tmpCliData.splice(i, 1);
                }
            }
        }
    }
    /**
     * 清理-服务端-数据包
     * 超过30秒-之后服务端不会重复下发丢包数据
     */
    clerSerData(){
        let time = Date.parse(new Date());
        for (let i in this.tmpSerData) {
            let data = this.tmpSerData[i];
            if (time - data.time > 30 * 1000){
                this.tmpSerData.splice(i, 1);
            }
        }
    }
    /**
     * 查找消息位置[上行数据]
     */
    findCliMsgId(msgId){
        for (let i = 0; i < this.tmpCliData.length;i++){
            if (this.tmpCliData[i].msgId == msgId) return this.tmpCliData[i];
        }
        return null;
    }
    /**
     * -确认帧【客户端包过滤】
     * @param data
     */
    ackFrame(data) {
        for (var i = 0; i < this.tmpCliData.length; i++) {
            if (this.tmpCliData[i].msgId == data.askId){
                if(this.tmpCliData[i].fn !== null) this.tmpCliData[i].fn(data.data);
                this.tmpCliData.splice(i, 1);
                break;
            }
        }
    }
    /**
     * 重复包检测【服务端主包】【服务端重发消息（重复包拦截）】
     */
    checkFrame(data){
        for(let i in this.tmpSerData) {
            let tmpData = this.tmpSerData[i];
            if(tmpData.data.id == data.id) {
                let sendAr = tmpData.data;
                if(sendAr.isAsk) {
                    let obj = new Message();
                    obj.code = sendAr.code;
                    obj.msgType = 2;
                    obj.askId = sendAr.id;
                    obj.data = "";//sendAr.data
                    obj.rests = sendAr.rests;
                    this.send(obj.getData(),false);
                    return true;
                }
                return true;
            }
        }
        return false;
    }
    /**
     * 解析包文件
     */
    asyMessage(uStr) {
        try{
            if(uStr instanceof ArrayBuffer) {
                return null;
            }
            //是否分割线
            var isEof = false;
            if(uStr.length >= 4) {
                //\r\n\r\n
                if(uStr[uStr.length - 1] == "\n"
                    && uStr[uStr.length - 2] == "\r"
                    && uStr[uStr.length - 3] == "\n"
                    && uStr[uStr.length - 4] == "\r"
                ) {
                    isEof = true;
                }
            }
            //获取全部数据
            if (isEof) {
                var unAr = [],unArStr = "";
                //累加之前数据分包
                for (var i in this.tmpData) {
                    if(this.tmpData[i] instanceof String)
                        unAr.push(this.tmpData[i]);
                }
                unArStr = unAr.join('');
                unArStr += uStr;
                this.tmpData = [];
                if(unArStr == "") return null;
                var AES = new CryptoJS.AES(this.opts.key);
                var data = AES.decrypt(unArStr.trim());
                if(data == "") return null;
                // console.log(data);
                return JSON.parse(data);
            } else {
                this.tmpData.push(uStr);
            }
        } catch(err) {
            console.log(err);
            return null;
        }
    }
    /**
     * 生成消息ID
     * @returns {string}
     */
    createMsgId(){
        this.incIndex ++;
        return "w" + this.fdSc + Date.parse(new Date()) + this.incIndex;
    }
    /**
     * 掉线从连接
     */
    reConnon() {
        clearInterval(this.timerId);
        clearInterval(this.retryTime);
        this.timerId = 0;
        this.retryTime = 0;
        let time = Date.parse(new Date());
        for (let i in this.tmpSerData) {
            let d = this.tmpSerData[i];
            if (time - d.time > 10 * 1000){
                this.tmpSerData.splice(i, 1);
            }
        }
        setTimeout(function () {
            if (this.socketTask.readyState == 3) {
                console.log('WebSocket重连接');
                this.connect();
            }
        }.bind(this), 2000);
    }

    extend($a, $b){
        let $r = [];for (var i in $b) {$r[i] = $b[i];}for (var i2 in $a) {if ($r[i2] == null) $r[i2] = $a[i2];}return $r;
    }
}




/**
 * websokcet
 * @param options
 * @returns {websocket}
 */
class wxSocket {
    readyState = 0; //1 开始 3关闭
    socket = null;
    opts = {
        wsUrl: "",
        onOpen:()=>{},
        onMessage:()=>{},
        onError:()=>{},
        onClose:()=>{}
    };


    constructor(opt) {
        this.opts = this.extend(this.opts,opt);
        this.onInit();
    }

    onInit(){
        //console.log(this.opts);
        //var szServer = "ws://" + this.opts.domain + ":" + this.opts.port + "/" + this.opts.protocol;
        //console.log(szServer);
        if(!("WebSocket" in window) && !("MozWebSocket" in window)){
            return false;
        }
        this.socket = new window.WebSocket(this.opts.wsUrl);
        if(this.opts.onInit){
            this.opts.onInit();
        }
        this.socket.onopen = (res)=>{this.onOpen(res);};
        this.socket.onmessage =  (res)=>{this.onMessage(res);};
        this.socket.onerror =  (res)=>{this.onError(res);};
        this.socket.onclose =  (res)=>{this.onClose(res);};
    }

    send(data) {
        this.socket.send(data.data);
    }

    onOpen(event){
        this.bOpen = true;
        if(this.opts.onOpen){
            this.readyState= 1;
            this.opts.onOpen(event);
        }
    }

    /**
     *
     * @param msg
     */
    onSend(msg){
        if(this.opts.onSend){
            this.opts.onSend(msg);
        }
        this.socket.send(msg);
    }

    /**
     *
     * @param msg
     */
    onMessage(msg){
        if(this.opts.onMessage){
            this.opts.onMessage(msg.data);
        }
    }

    /**
     *
     * @param event
     */
    onError(event){
        console.log(event);
        if(this.opts.onError){
            this.readyState = 3;
            this.opts.onError(event);

        }
    }

    /**
     *
     * @param event
     */
    onClose(event){
        if(this.opts.onClose){
            this.readyState = 3;
            this.opts.onClose(event);
        }
        if(this.socket.close() != null){
            this.socket = null;
        }
    }


    extend($a, $b){
        let $r = [];for (var i in $b) {$r[i] = $b[i];}for (var i2 in $a) {if ($r[i2] == null) $r[i2] = $a[i2];}return $r;
    }
}
